import { Link } from "react-router-dom"
import { BookOpen, Award, FileText, Users } from "lucide-react"

export default function AcademicsResearch() {
  const sections = [
    {
      title: "Pranaam Knowledge",
      description: "Advancing medical education and training programs",
      icon: BookOpen,
      link: "/academics/knowledge",
      image: "/images/WomensHealthcareTeam.png"
    },
    {
      title: "Research and Innovations",
      description: "Pioneering research in women's and children's healthcare",
      icon: Award,
      link: "/academics/research",
      image: "/images/ResearchExcellence.png"
    },
    {
      title: "Excellence Report",
      description: "Our commitment to quality healthcare delivery",
      icon: FileText,
      link: "/academics/excellence-report",
      image: "/images/PranaamHospitalsAwards.png"
    },
    {
      title: "Research Publications",
      description: "Published studies and medical research papers",
      icon: FileText,
      link: "/academics/publications",
      image: "/images/HealthcareSpectrum.png"
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Academics & Research</h1>
          <p className="text-lg md:text-xl text-white/90">Advancing Healthcare Through Education and Innovation</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {sections.map((section) => {
            const Icon = section.icon
            return (
              <Link
                key={section.link}
                to={section.link}
                className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-shadow overflow-hidden group"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={section.image}
                    alt={section.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900">{section.title}</h2>
                  </div>
                  <p className="text-gray-600">{section.description}</p>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
